import React, { useState } from 'react';
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Phone, Mail, Linkedin, Facebook, ChevronDown } from 'lucide-react';
// Mock Data for Employee Headcount (2010 - 2025)
const headcountData = [{
  date: 'Jan-10',
  count: 85
}, {
  date: 'Jul-10',
  count: 88
}, {
  date: 'Jan-11',
  count: 92
}, {
  date: 'Jul-11',
  count: 95
}, {
  date: 'Jan-12',
  count: 98
}, {
  date: 'Jul-12',
  count: 102
}, {
  date: 'Jan-13',
  count: 105
}, {
  date: 'Jul-13',
  count: 108
}, {
  date: 'Jan-14',
  count: 112
}, {
  date: 'Jul-14',
  count: 115
}, {
  date: 'Jan-15',
  count: 118
}, {
  date: 'Jul-15',
  count: 120
}, {
  date: 'Jan-16',
  count: 122
}, {
  date: 'Jul-16',
  count: 125
}, {
  date: 'Jan-17',
  count: 128
}, {
  date: 'Jul-17',
  count: 130
}, {
  date: 'Jan-18',
  count: 135
}, {
  date: 'Jul-18',
  count: 138
}, {
  date: 'Jan-19',
  count: 142
}, {
  date: 'Jul-19',
  count: 145
}, {
  date: 'Jan-20',
  count: 148
}, {
  date: 'Jul-20',
  count: 150
}, {
  date: 'Jan-21',
  count: 155
}, {
  date: 'Jul-21',
  count: 158
}, {
  date: 'Jan-22',
  count: 162
}, {
  date: 'Jul-22',
  count: 165
}, {
  date: 'Jan-23',
  count: 168
}, {
  date: 'Jul-23',
  count: 172
}, {
  date: 'Jan-24',
  count: 175
}, {
  date: 'Jul-24',
  count: 178
}, {
  date: 'Jan-25',
  count: 182
}, {
  date: 'Jul-25',
  count: 185
}];
// Mock Data for Headcount by Role (2018 - 2025)
const roleData = [{
  date: 'Jan-18',
  Production: 65,
  Sales: 18,
  Operations: 15,
  Accounting: 6,
  HR: 4,
  RD: 12,
  CS: 8,
  Management: 7
}, {
  date: 'Jul-18',
  Production: 68,
  Sales: 18,
  Operations: 15,
  Accounting: 6,
  HR: 4,
  RD: 12,
  CS: 8,
  Management: 7
}, {
  date: 'Jan-19',
  Production: 70,
  Sales: 19,
  Operations: 16,
  Accounting: 6,
  HR: 4,
  RD: 13,
  CS: 8,
  Management: 6
}, {
  date: 'Jul-19',
  Production: 72,
  Sales: 19,
  Operations: 16,
  Accounting: 6,
  HR: 4,
  RD: 13,
  CS: 8,
  Management: 7
}, {
  date: 'Jan-20',
  Production: 74,
  Sales: 20,
  Operations: 16,
  Accounting: 6,
  HR: 4,
  RD: 14,
  CS: 8,
  Management: 6
}, {
  date: 'Jul-20',
  Production: 75,
  Sales: 20,
  Operations: 17,
  Accounting: 6,
  HR: 4,
  RD: 14,
  CS: 8,
  Management: 6
}, {
  date: 'Jan-21',
  Production: 78,
  Sales: 21,
  Operations: 17,
  Accounting: 7,
  HR: 4,
  RD: 14,
  CS: 8,
  Management: 6
}, {
  date: 'Jul-21',
  Production: 80,
  Sales: 21,
  Operations: 17,
  Accounting: 7,
  HR: 4,
  RD: 15,
  CS: 8,
  Management: 6
}, {
  date: 'Jan-22',
  Production: 82,
  Sales: 22,
  Operations: 18,
  Accounting: 7,
  HR: 5,
  RD: 15,
  CS: 9,
  Management: 4
}, {
  date: 'Jul-22',
  Production: 84,
  Sales: 22,
  Operations: 18,
  Accounting: 7,
  HR: 5,
  RD: 15,
  CS: 9,
  Management: 5
}, {
  date: 'Jan-23',
  Production: 86,
  Sales: 23,
  Operations: 18,
  Accounting: 7,
  HR: 5,
  RD: 16,
  CS: 9,
  Management: 4
}, {
  date: 'Jul-23',
  Production: 88,
  Sales: 24,
  Operations: 19,
  Accounting: 7,
  HR: 5,
  RD: 16,
  CS: 9,
  Management: 4
}, {
  date: 'Jan-24',
  Production: 90,
  Sales: 24,
  Operations: 19,
  Accounting: 7,
  HR: 5,
  RD: 17,
  CS: 9,
  Management: 4
}, {
  date: 'Jul-24',
  Production: 92,
  Sales: 25,
  Operations: 19,
  Accounting: 7,
  HR: 5,
  RD: 17,
  CS: 9,
  Management: 4
}, {
  date: 'Jan-25',
  Production: 94,
  Sales: 25,
  Operations: 20,
  Accounting: 8,
  HR: 5,
  RD: 18,
  CS: 9,
  Management: 3
}, {
  date: 'Jul-25',
  Production: 96,
  Sales: 26,
  Operations: 20,
  Accounting: 8,
  HR: 5,
  RD: 18,
  CS: 9,
  Management: 3
}];
const departments = [{
  key: 'Production',
  color: '#8b5cf6',
  label: 'Production'
}, {
  key: 'Sales',
  color: '#4f46e5',
  label: 'Sales'
}, {
  key: 'Operations',
  color: '#0ea5e9',
  label: 'Operations'
}, {
  key: 'RD',
  color: '#ec4899',
  label: 'R&D'
}, {
  key: 'Accounting',
  color: '#10b981',
  label: 'Accounting'
}, {
  key: 'HR',
  color: '#f59e0b',
  label: 'Human Resources'
}, {
  key: 'CS',
  color: '#06b6d4',
  label: 'Customer Service'
}, {
  key: 'Management',
  color: '#ef4444',
  label: 'Management'
}];
const principals = [{
  name: 'Willy Wonka',
  role: 'Owner & Chief Chocolatier',
  phone: '(555) 555-0100',
  email: 'willy.wonka@wonka.com',
  status: 'Current',
  previous: ['Wonka Chocolate Factory (1971-Present)'],
  socials: ['linkedin'],
  linkedin: '#'
}, {
  name: 'Charlie Bucket',
  role: 'Factory Manager',
  phone: '(555) 555-0200',
  email: 'charlie.bucket@wonka.com',
  status: 'Current',
  previous: [],
  socials: ['linkedin'],
  linkedin: '#'
}];
export function WonkaPeopleTab() {
  const [activeDepartments, setActiveDepartments] = useState<string[]>(departments.map(d => d.key));
  const toggleDepartment = (key: string) => {
    if (activeDepartments.includes(key)) {
      setActiveDepartments(activeDepartments.filter(d => d !== key));
    } else {
      setActiveDepartments([...activeDepartments, key]);
    }
  };
  const toggleAll = () => {
    if (activeDepartments.length === departments.length) {
      setActiveDepartments([]);
    } else {
      setActiveDepartments(departments.map(d => d.key));
    }
  };
  return <div className="space-y-6 mt-6" data-id="element-4270" data-mp="34493rym3b4ta">
      {/* Employee Headcount Chart */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-4271" data-mp="2z5o5i4qeev7h">
        <div className="flex justify-between items-start mb-6" data-id="element-4272" data-mp="3d4xae895m2w5">
          <div data-id="element-4273" data-mp="3d22oecahsa0m">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-4274" data-mp="39328b1jeflhb">
              Employee Headcount
            </h2>
            <div className="inline-block border-b-2 border-gray-900 pb-1 mb-1" data-id="element-4275" data-mp="3n21u81fj1m9s">
              <span className="text-xl font-bold text-gray-900" data-id="element-4276" data-mp="3i3icyebvoynr">8%</span>
            </div>
            <p className="text-sm text-gray-600" data-id="element-4277" data-mp="n0q7qyear4d">12 Month Growth Rate</p>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-4278" data-mp="p3gmc3gmm9m">
            ALL <ChevronDown className="w-4 h-4" data-id="element-4279" data-mp="9oqewp0w7byg" />
          </button>
        </div>
        <div className="h-72 w-full" data-id="element-4280" data-mp="4p422goz7xq6">
          <ResponsiveContainer width="100%" height="100%" data-id="element-4281" data-mp="4q6uwu5v0a8q">
            <LineChart data={headcountData} margin={{
            top: 5,
            right: 0,
            left: -20,
            bottom: 0
          }} data-id="element-4282" data-mp="o9vzb3l85k4n">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-4283" data-mp="f8o10lipkjak" />
              <XAxis dataKey="date" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} minTickGap={30} data-id="element-4284" data-mp="jd5k0ih8uska" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 200]} ticks={[0, 50, 100, 150, 200]} data-id="element-4285" data-mp="3rsp52u7rh4o9" />
              <Tooltip contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
            }} data-id="element-4286" data-mp="3nozmcldrphb5" />
              <Line type="monotone" dataKey="count" stroke="#000000" strokeWidth={2} dot={false} activeDot={{
              r: 6,
              fill: '#000000'
            }} data-id="element-4287" data-mp="3t9cq4r51if8i" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Company Principals Table */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-4288" data-mp="3aibsc6fnopqj">
        <div className="p-6 border-b border-gray-200" data-id="element-4289" data-mp="35k1xjwxufr5g">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-4290" data-mp="35llcnk7rjw5n">
            Company Principals
          </h2>
        </div>
        <div className="overflow-x-auto" data-id="element-4291" data-mp="31jzupkgdgrol">
          <table className="w-full text-left border-collapse" data-id="element-4292" data-mp="2witznfz8osbw">
            <thead data-id="element-4293" data-mp="1c11mvcu4ewvu">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-4294" data-mp="1c1ku9zm5a2vm">
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-4295" data-mp="1c3e05coxoj2k">
                  Name
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-4296" data-mp="1l1zhx5mkzu2a">
                  Role
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-4297" data-mp="1pzrisp57eqim">
                  Phone/Email
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-4298" data-mp="tcejcyrlefkd">
                  Status
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-4299" data-mp="x9ss6pbd2lbu">
                  Previous Employers
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600 text-right" data-id="element-4300" data-mp="17284p73w2hpc">
                  Socials
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-4301" data-mp="eldzlxleaz8x">
              {principals.map((principal, idx) => <tr key={idx} className="hover:bg-gray-50/50" data-id="element-4302" data-mp="2oqecrpr1xd4y" data-mpi={idx}>
                  <td className="px-6 py-4" data-id="element-4303" data-mp="2orxvro43e2af">
                    <span className="font-bold text-gray-900" data-id="element-4304" data-mp="2sqorprwtndvy">
                      {principal.name}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600" data-id="element-4305" data-mp="2xogmctoupe3u">
                    {principal.role}
                  </td>
                  <td className="px-6 py-4" data-id="element-4306" data-mp="2525kzgtf795z">
                    <div className="space-y-1" data-id="element-4307" data-mp="253gn7c77w8uz">
                      <div className="flex items-center gap-2 text-sm" data-id="element-4308" data-mp="2a0p7bibxemyv">
                        <Phone className="w-4 h-4 text-gray-400" data-id="element-4309" data-mp="29yw1245864re" />
                        <a href={`tel:${principal.phone}`} className="text-indigo-600 hover:underline" data-id="element-4310" data-mp="2ez9xsq1dlsa4">
                          {principal.phone}
                        </a>
                      </div>
                      <div className="flex items-center gap-2 text-sm" data-id="element-4311" data-mp="1r9pbpy9xeewm">
                        <Mail className="w-4 h-4 text-gray-400" data-id="element-4312" data-mp="1jqoge09a3rkc" />
                        <a href={`mailto:${principal.email}`} className="text-indigo-600 hover:underline" data-id="element-4313" data-mp="1jq6lp829llej">
                          {principal.email}
                        </a>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-4314" data-mp="10s3vipxzdif5">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${principal.status === 'Current' ? 'bg-gray-100 text-gray-800 border border-gray-200' : 'bg-gray-100 text-gray-500 border border-gray-200'}`} data-id="element-4315" data-mp="10svnzrwa7017">
                      {principal.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-4316" data-mp="h31pyw2z3ooj">
                    {principal.previous.length > 0 ? <ul className="list-disc list-inside text-sm text-gray-600 space-y-0.5" data-id="element-4317" data-mp="d3kkw3rgktjw">
                        {principal.previous.map((prev, i) => <li key={i} data-id="element-4318" data-mp="7gh8iopa2eah" data-mpi={i}>{prev}</li>)}
                      </ul> : <span className="text-sm text-gray-400" data-id="element-4319" data-mp="3pmvqcyqo38e5">-</span>}
                  </td>
                  <td className="px-6 py-4" data-id="element-4320" data-mp="3ulzw1fedunzq">
                    <div className="flex items-center justify-end gap-2" data-id="element-4321" data-mp="3un1ieg0umwwr">
                      {principal.socials.includes('linkedin') && <a href={principal.linkedin} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-[#0077b5] flex items-center justify-center text-white hover:opacity-90 transition-opacity" data-id="element-4322" data-mp="q5xcjm068ovn">
                          <Linkedin className="w-4 h-4" data-id="element-4323" data-mp="152ely7osvtfk" />
                        </a>}
                      {principal.socials.includes('facebook') && <a href="#" className="w-8 h-8 rounded-full bg-[#1877f2] flex items-center justify-center text-white hover:opacity-90 transition-opacity" data-id="element-4324" data-mp="1j7yj7rzz7emp">
                          <Facebook className="w-4 h-4" data-id="element-4325" data-mp="1o0rnyfvg2mys" />
                        </a>}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}